import { css } from '@emotion/react';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
} from '@mui/material';
import { ClubLogo } from '@scorenco/components';
import { Types, useTranslation, useUpdateEngagmentTeam } from '@scorenco/core';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import { T_KEYS } from '@/translations';

import { PhaseName } from '../../PhaseName';

type GroupTeamsProps = {
  challengeTeams: Types.Tournaments_Team[];
  phase: Types.Tournaments_Phase;
  engagements: Types.Tournaments_Engagement[];
  gameName?: string;
};

export const GroupTeams = ({
  challengeTeams,
  phase,
  engagements,
  gameName,
}: GroupTeamsProps) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const engagmentTeamMutation = useUpdateEngagmentTeam();

  const teams =
    // engagements?.length > 2 &&
    // (rule.rule_type === 1 || rule.rule_type === 5 || rule.rule_type === 6) &&
    engagements;

  const formik = useFormik({
    initialValues: {
      teams:
        engagements.map((team) => {
          return team.team?.id || null;
        }) || [],
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        engagements.map(async (engagment, index) => {
          await engagmentTeamMutation.execute({
            deletedTeam: values.teams.includes(engagment.team_id)
              ? null
              : engagment.team_id,
            engagmentId: engagment.id,
            teamId: values.teams[index],
          });
        });
        enqueueSnackbar(t(T_KEYS.SUCCESS_EDIT), {
          variant: 'success',
        });
      } catch (error) {
        console.error('error: ', error);
        enqueueSnackbar(t(T_KEYS.ERROR_MESSAGE), {
          variant: 'error',
        });
      }
    },
  });

  return (
    <>
      {teams && (
        <Box
          sx={{
            m: '0',
            p: 2,
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
          component="form"
          onSubmit={formik.handleSubmit}
        >
          {teams?.length > 2 ? (
            <PhaseName phase={phase} />
          ) : (
            <Chip
              label={gameName}
              color="primary"
              sx={{ mb: 2 }}
              size="small"
            />
          )}

          {teams?.map((engagement, idxEngagement) => (
            <Box
              key={`${idxEngagement}`}
              css={css`
                display: flex;
                padding: 0.75rem 1rem;
                font-size: 0.875rem;
              `}
            >
              <Box
                css={css`
                  margin-left: 0.25rem;
                  flex: 1;
                  display: flex;
                  flex-direction: row;
                  align-items: center;
                  justify-content: center;
                `}
              >
                <FormControl sx={{ width: '15rem' }} size="small">
                  <InputLabel id="teams">{engagement?.name}</InputLabel>
                  <Select
                    id="teams"
                    name="teams"
                    size="small"
                    label={engagement?.name}
                    value={formik.values.teams[idxEngagement]}
                    onChange={(e) => {
                      formik.setFieldValue(
                        'teams',
                        formik.values.teams.map((team, index) => {
                          if (index === idxEngagement) {
                            return e.target.value;
                          } else {
                            return team;
                          }
                        })
                      );
                    }}
                  >
                    <MenuItem value={null}>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        <ClubLogo
                          style={{
                            height: '1.5rem',
                            width: '1.25rem',
                            marginRight: '1rem',
                          }}
                          logo=""
                          name=""
                          shieldColor="home"
                        />
                        {t(T_KEYS.CHALLENGES_NO_TEAM_SELECTED)}
                      </Box>
                    </MenuItem>
                    {challengeTeams
                      ?.filter((team) =>
                        team.engagements?.find(
                          (engagement) => engagement.phase_id === phase.id
                        ) || team.engagements?.length === 0
                          ? !formik.values.teams.includes(team.id) ||
                            formik.values.teams[idxEngagement] === team.id
                          : false
                      )
                      .map((team) => {
                        return (
                          <MenuItem value={team.id} key={team.id}>
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'row',
                              }}
                            >
                              <ClubLogo
                                style={{
                                  height: '1.5rem',
                                  width: '1.25rem',
                                  marginRight: '1rem',
                                }}
                                logo={team.logo}
                                name={team.name}
                                shieldColor="home"
                              />
                              {team.name}
                            </Box>
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Box>
            </Box>
          ))}
          <Stack direction="row" alignItems="center" mt={2} gap={1}>
            <LoadingButton
              variant="contained"
              color="secondary"
              type="submit"
              size="small"
              loading={engagmentTeamMutation.status.loading}
              disabled={
                String(
                  engagements.map((team) => {
                    return team.team?.id || null;
                  })
                ) === String(formik.values.teams)
              }
            >
              Enregistrer les équipes
            </LoadingButton>
            {/* <ModalLink
              //  Modal={EditRulesModal}
              modalProps={{
                phaseId: phase.id,
              }}
            >
              <IconButton color="primary">
                <Edit />
              </IconButton>
            </ModalLink> */}
          </Stack>
        </Box>
      )}
    </>
  );
};
